export default __webpack_public_path__ + "static/media/iread_22_10.9243f601.jpg";